import React, { useContext } from "react";
import FloatingCard from "../components/FloatingCard/FloatingCard";
import Header from "../components/Header/Header";
import Main from "../components/Main/Main";
import Sidebar from "../components/Sidebar/Sidebar";
import { Context } from "../context/Context";
export default function Home() {
  const {  isOpen } = useContext(Context);

  return (
    <div className="w-full h-screen bg-white font-Blinker  ease-in-out  ">
      <Header />
      <Sidebar
        classList={`transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      />
      <div className="w-full min-h-vm flex relative top-0 ">
        <div
          className={`transform duration-700  min-h-vm  flex items-center justify-center px-6 ${
            !isOpen ? "w-full" : "lgx:pl-80"
          } flex-1 flex `}
        >
          <Main />
        </div>
      </div>
      <FloatingCard />
    </div>
  );
}
